<template>
  <v-card class="card-content-container">
    <v-card-title style="display: flex; justify-content: center">
      {{ mode }}
    </v-card-title>
    <v-form
      @submit.prevent="submitForm"
      ref="form"
      v-model="valid"
      class="mx-auto px-4"
      style="max-width: 1500px"
    >
      <v-alert
        dense
        v-if="error"
        color="red"
        elevation="5"
        outlined
        text
        type="error"
        align="center"
        class="mx-1 mb-5"
      >
        {{ alertValidate }}</v-alert
      >
      <div class="mx-auto">
        <v-text-field
          v-for="(input, i) in inputsForm"
          :key="'input_' + i + input.name"
          :name="input.name"
          v-model="input.data"
          :type="input.type"
          :label="input.label"
          :rules="input.rules"
          outlined
          dense
          class="ma-0"
          :readonly="input.readonly"
          :disabled="input.disabled"
        />
        <div
          v-for="(checkbox, index) in checkboxes"
          :key="'checkbox_' + index + checkbox.name"
          class="d-block"
        >
          <v-checkbox
            v-model="checkbox.data"
            :label="checkbox.label"
            :name="checkbox.name"
            :value="checkbox.data"
            class="ma-0"
            @change="handleCheckboxChange(checkbox)"
          />
        </div>
        <div
          v-if="modo === 'Editar' && editEmployeed.length >= 0"
          height="100"
          class="mx-n2"
        >
          <TableWithSearch
            :key="tableKey"
            :items="editEmployeed"
            :title="title"
            :headers="allHeaders"
            @headersUpdated="updateHeadersOperadores"
            @refreshItems="refreshItems"
            :showRefresh="true"
            :openDialog="openDialogEmp"
          />
        </div>
        <div class="d-flex justify-space-between py-4">
          <v-btn class="bt-exit" @click="cancel">{{
            $tc("editRegistrations.cancel")
          }}</v-btn>
          <v-btn type="submit" class="bt-acept">
            {{ $tc("editRegistrations.acept") }}</v-btn
          >
        </div>
      </div>
    </v-form>
    <v-dialog v-model="openEmployeed" :max-width="'580px'" persistent>
      <Form
        :key="modeEmployeed"
        :itemsSelect="selectsData"
        :disableSelect="disableSelectModo()"
        @save="save"
        @cancel="reset"
        :maxWidth="'580px'"
        :show="true"
        :mode="modeEmployeed"
        :showDate="true"
        :showDateFrom="true"
        :showDateTo="true"
        :showCheck="true"
      />
    </v-dialog>
    <DeleteDialog
      :showDialog="openDeleteEmployeed"
      :title="titleDeleteEmployeed"
      :confirmDelete="deleteItem"
      :cancelDelete="cancelDelete"
      :maxWidth="'500px'"
    />
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-card>
</template>
<script>
import cards from "../../../../store/tarjetas/cards";
import date from "@/store/common/date";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import DateWithCheck from "@/components/Complement/DateWithCheck.vue";
import Form from "@/components/Complement/Form.vue";
import Vue from "vue";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import moment from "moment";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    DateWithCheck,
    Date,
    Form,
    TableWithSearch,
    DeleteDialog,
    Snackbar,
  },
  props: {
    items: {
      type: Array,
    },
    maxWidth: String,
    mode: String,
    itemsSelect: Array,
    show: {
      type: Boolean,
      default: false,
    },
    itemsSlider: Array,
    showDate: Boolean,
    showCheck: Boolean,
    multiple: Boolean,
    itemsCheckbox: Array,
  },
  data() {
    return {
      tableKey: 0,
      titleTable: "Tarjetas_y_Relaciones",
      title: "Empleados",
      inputsForm: [],
      valid: true,
      error: false,
      alertValidate: "",
      selects: [],
      inputSlider: [],
      checkboxes: [],
      oldItems: {},
      titleDeleteEmployeed: this.$tc("cards.deleteEmployeed"),
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      modoItem: "",
    };
  },
  mounted() {
    this.checkboxes = Vue.observable(this.itemsCheckbox);
    this.inputsForm = Vue.observable(this.items);
    cards.dispatch("getEmployeed");
  },
  computed: {
    allHeaders() {
      return configTable.state.colums.operadores;
    },
    getEmployeed() {
      return cards.state.employees;
    },
    modo() {
      if (this.mode === this.$tc("cards.addCard")) {
        return this.$tc("commons.add");
      } else {
        return this.$tc("commons.edit");
      }
    },
    modeEmployeed: {
      get() {
        return cards.state.modeEmployeed;
      },
      set(newValue) {
        return newValue;
      },
    },
    openEmployeed: {
      get() {
        return cards.state.openEmployeed;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDeleteEmployeed: {
      get() {
        return cards.state.openDeleteEmployeed;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    selectsData() {
      return [
        {
          name: "empId",
          label: this.$tc("cards.employeed"),
          data: [],
          items: this.getEmployeed,
          itemsValue: "empId",
          itemsText: (item) => `${item.name} (${item.legajo})`,
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
        },
      ];
    },
    employeesArray() {
      return cards.state.edit.Employees ? cards.state.edit.Employees : [];
    },
    editEmployeed() {
      const employees = this.employeesArray;
      const grouped = employees.reduce((acc, emp) => {
        if (!acc[emp.empNombre]) {
          acc[emp.empNombre] = [];
        }
        acc[emp.empNombre].push(emp);
        return acc;
      }, {});

      const sortedGrouped = Object.keys(grouped).map((name) => {
        return grouped[name].sort((a, b) => {
          const dateA = moment(a.fecDesde, "DD-MM-YYYY");
          const dateB = moment(b.fecDesde, "DD-MM-YYYY");
          return dateB - dateA;
        });
      });

      return sortedGrouped.flat();
    },
  },
  watch: {
    "cards.state.edit.Employees": {
      handler(newValue) {
        if (newValue) {
          // Forzar que se reactive employeesArray
          this.forceEmployeesArrayUpdate();
        }
      },
      immediate: true, // Para que se ejecute al montar el componente
    },
  },

  methods: {
    forceEmployeesArrayUpdate() {
      // Cambia la referencia para asegurar reactividad
      if (Array.isArray(cards.state.edit.Employees)) {
        cards.state.edit.Employees = [...cards.state.edit.Employees];
      } else {
        cards.state.edit.Employees = [];
      }
    },
    updateHeadersOperadores(headers) {
      const updatedColums = {
        ...configTable.state.colums,
        operadores: headers,
      };

      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    disableSelectModo() {
      if (this.modoItem === "edit") {
        return true;
      } else {
        return false;
      }
    },
    openEditForm(item) {
      this.selectsData[0].label = item.empNombre;
      this.selectsData[0].data = item.empId;
      date.state.dateFrom = moment(item.fecDesde, "DD-MM-YYYY").format(
        "YYYY-MM-DD"
      );
      if (item.fecHasta !== "") {
        date.state.dateTo = moment(item.fecHasta, "DD-MM-YYYY").format(
          "YYYY-MM-DD"
        );
        date.state.checkTo = false;
      } else {
        date.state.checkTo = true;
      }
      cards.commit("setOpenEmployeed", true);
    },
    submitForm(e) {
      e.preventDefault();
      this.validation(e.target);
    },

    resetDate() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
      date.commit("setCheckTo", null);
    },

    reset() {
      this.resetDate();
      cards.commit("setModeEmployeed", "");
      cards.commit("setOpenEmployeed", false);
      (this.selectsData[0].label = this.$tc("cards.employeed")),
        this.selectsData.forEach((item) => {
          item.data = "";
        });
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    save(items) {
      switch (this.typeForm) {
        case "add":
          this.addEmployeedItem(items);
          break;
        case "edit":
          this.editEmployeedItem(items);
          break;
        default:
          break;
      }
    },
    addEmployeedItem(items) {
      let payload = items;
      payload.fecDesde = date.state.dateFrom;
      if (!date.state.checkTo) {
        payload.fecHasta = date.state.dateTo;
      }
      payload.operId = localStorage.getItem("operId");
      payload.tarjId = cards.state.edit.id;

      cards.commit("setNewEmployeed", payload);
      cards
        .dispatch("newEmployeed")
        .then(() => {
          cards.commit("setOpenEmployeed", false);
          this.showAlert(this.$tc("cards.addEmployeedSuccess"), "#82A1D0");
        })
        .catch((e) => {
          this.showAlert(e.response.data.error.message, "#ff8d58");
        });
      this.reset(false);
    },

    sendEdit(updatedItem) {
      cards.commit("setEditEmployeed", updatedItem);
      cards
        .dispatch("editEmployeedItem")
        .then(() => {
          cards.commit("setOpenEmployeed", false);
          this.showAlert(this.$tc("cards.editEmpleadoAlertSuccess"), "#82A1D0");
        })
        .catch((e) => {
          console.error("Error al aplicar los cambios:", e);
          this.showAlert(e.response.data.error.message, "#ff8d58");
        });
      this.reset(false);
    },

    editEmployeedItem() {
      let empleyedOld = this.oldItems;
      let changes = {};
      // fecha desde
      empleyedOld.fecDesde = moment(empleyedOld.fecDesde, "DD-MM-YYYY").format(
        "YYYY-MM-DD"
      );
      if (date.state.dateFrom !== empleyedOld.fecDesde) {
        changes.fecDesdeNew = date.state.dateFrom;
      }
      // fecha hasta
      if (empleyedOld.fecHasta !== null) {
        empleyedOld.fecHasta = moment(
          empleyedOld.fecHasta,
          "DD-MM-YYYY"
        ).format("YYYY-MM-DD");

        if (date.state.dateTo !== empleyedOld.fecHasta) {
          changes.fecHastaNew = date.state.dateTo;
        }
      }

      if (date.state.checkTo) {
        changes.haNoEx = true;
        delete changes.fecHastaNew;
      }

      if (Object.keys(changes).length > 0) {
        const updatedItem = { ...empleyedOld, ...changes };
        this.sendEdit(updatedItem);
      } else {
        cards.commit("setOpenEmployeed", false);
        this.showAlert(this.$tc("cards.editEmpleadoAlertError"), "#f1c232");
      }
    },

    handleSubmit(form) {
      const formData = new FormData(form);
      const itemsComplete = {};

      for (let [name, value] of formData) {
        itemsComplete[name] = value;
      }
      this.$refs.form.resetValidation();
      this.$emit("save", itemsComplete);
    },
    cancel() {
      this.$refs.form.resetValidation();
      this.$emit("cancel", false);
    },
    forceForm() {
      this.$emit("force-form");
    },
    validation(form) {
      let valid = this.$refs.form.validate();
      if (valid) {
        this.handleSubmit(form);
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },
    handleChange(i) {
      console.log(i);
    },
    async openDialogEmp(type, item) {
      this.typeForm = type;
      switch (this.typeForm) {
        case "add":
          this.modoItem = "add";
          date.state.checkTo = true;
          await cards.commit(
            "setModeEmployeed",
            this.$tc("cards.addCardEmployeed")
          );
          cards.commit("setOpenEmployeed", true);
          break;
        case "edit":
          this.modoItem = "edit";
          this.oldItems = item;
          this.itemId = item.empId;
          await cards.commit(
            "setModeEmployeed",
            this.$tc("cards.editCardEmployeed")
          );
          await this.openEditForm(item);
          break;
        case "delete":
          cards.commit("setOpenDeleteEmployeed", true);
          item.fecDesde = moment(item.fecDesde, "DD-MM-YYYY").format(
            "YYYY-MM-DD"
          );
          this.itemToDelete = item;
          break;
        default:
          break;
      }
    },
    deleteItem() {
      cards.commit("setItemDelete", this.itemToDelete);
      cards
        .dispatch("deleteEmployeed")
        .then(() => {
          cards.commit("setOpenDeleteEmployeed", false);
          this.showAlert(this.$tc("cards.deleteEmployeedSuccess"), "#82A1D0");
        })
        .catch((e) => {
          this.showAlert(e.response.data.error.message, "#ff8d58");
        });
    },
    cancelDelete() {
      cards.commit("setOpenDeleteEmployeed", false);
    },
    async refreshItems() {
      let itemId = cards.state.edit.id;

      // Obtener los datos de nuevo
      await cards.dispatch("getCardData", itemId);

      this.forceForm();
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 1520px;
}

.slider-input {
  display: flex !important;
  justify-content: center !important;
  align-items: flex-end !important;
}

.slider-container {
  border: 1px solid #959595;
  margin-bottom: 30px;
  height: 110px;
}

.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}

.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
.card-content-container {
  max-width: 1500px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
